require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-animate/index.js
// module id = 1330
// module chunks = 2